import { Component, OnInit, Input } from '@angular/core';
import { Logging } from '../../logging';

@Component({
  selector: 'app-trans-other-details',
  templateUrl: './trans-other-details.component.html',
  styleUrls: []
})
export class TransOtherDetailsComponent {

  iswallet : boolean = false;
  isbank : boolean = false;

  @Input() transid;
  @Input() channel;
  @Input() brandtransid;


  constructor() { }

  ngOnInit() {

    Logging.log(this.transid + " : "+this.channel + " : "+this.brandtransid);
  }

}



// WEBPACK FOOTER //
// ./src/app/client/trans-other-details/trans-other-details.component.ts